import { RESOURCES } from '@elementary/common-ui/constants/queryKeys';
import useGraphqlQuery from '@elementary/common-ui/hooks/useGraphqlQuery';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';
import { getTestManagementAssetsQuery } from 'shared/services/api';
import {
  Resource,
  TestManagementGqlAsset,
  TestManagementGqlAssetsResponse,
} from 'shared/types';

const normalizeAsset = (asset: TestManagementGqlAsset): Resource => ({
  id: asset.id,
  name: asset.name,
  schema: asset.schemaName,
  table_name: asset.tableName,
  db_name: asset.dbName,
  source_name: asset.sourceName ?? undefined,
  source_type: asset.sourceType,
  materialization: asset.materialization ?? undefined,
  table_type: asset.tableType.toLowerCase(),
  fqn: asset.fqn,
  tags: asset.tags,
  owners: asset.owners,
  columns: [],
  cloud_tests_supported: {
    freshness_anomalies: asset.cloudTestsSupported.freshnessAnomalies,
    volume_anomalies: asset.cloudTestsSupported.volumeAnomalies,
    data_contract: asset.cloudTestsSupported.dataContract,
    pipeline_task_performance:
      asset.cloudTestsSupported.pipelineTaskPerformance,
  },
});

type Props = {
  enabled?: boolean;
  onError?: () => void;
};

const useTestManagementAssets = ({ enabled = true, onError }: Props = {}) => {
  const selectedEnvId = useSelectedEnv();

  return useGraphqlQuery<Resource[]>({
    query: getTestManagementAssetsQuery,
    queryKey: [RESOURCES, selectedEnvId],
    enabled,
    onError,
    select: (data: TestManagementGqlAssetsResponse) =>
      (data?.tableAssets?.items ?? [])
        .filter((asset) => asset.canCreateTests)
        .map(normalizeAsset),
  });
};

export default useTestManagementAssets;
